<div class="d-flex justify-content-between align-items-center" mat-dialog-title>
    <h1 class="condensed dialog-title">Wijzigingshistorie prijs</h1>
    <div class="dialog-close">
        <div (click)="onNoClick()" class="fab small active" id="btn-cancel">
            <i class="fas fa-times"></i>
        </div>
    </div>
</div>
<div class="dialog-content flex-column" mat-dialog-title>
    @for (log of priceLogs(); track log) {
        <div class="log-item">
            <b>{{log.user}}</b> heeft de prijs van <b>{{log.material}}</b> aangepast van
            {{log.old | currency : 'EUR'}} naar <b>{{log.new | currency : 'EUR'}}</b>
            op {{log.updated_at | date : 'd MMMM yyyy'}} om {{log.updated_at | date : 'H:mm'}} uur
        </div>
    }
    @if (priceLogs() && priceLogs().length < 1) {
        <div class="log-item">
            Er zijn nog geen wijzigingen
        </div>
    } @else if (!priceLogs()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
</div>

